import React, { useState } from "react";
import { PrimaryButton, Dialog, DialogFooter } from '@fluentui/react';
import { renderUser } from "../../../helpers/HelperMethods";
import { PowerAppSolutionChangeTaskType } from "../../../GlobalConst/globalEnums";

const DeletePowerAppSolutionConfirmationDialog = ({solution, onDialogClosed}) => {

    const [showDialog, setShowDialog] = useState(true)

    const deletionTask = solution.changeTasks.find(x => x.type === PowerAppSolutionChangeTaskType.delete)

    const closeDialog = () => {
        setShowDialog(false)
        onDialogClosed();
    }

    const requestSavedDialog = 
        <Dialog 
            hidden={!showDialog}
            maxWidth={600}
            dialogContentProps={{
                title: `Deletion Request Saved`,
            }}
            modalProps={{
                isBlocking: false
            }}
            onDismiss={closeDialog}
        >
            <div>
                {
                    deletionTask && deletionTask.approver
                    ? <div>
                        <div>A deletion approval has been sent to the environment owner ({renderUser(deletionTask.approver)})</div>
                        <div>Unless the environment owner rejects the request, the solution will be deleted.</div>
                        <div>You will be notified once a decision is made.</div>
                    </div>
                    : <div>
                        This solution will be backed up for 6 months. <br />
                        During this period, environment owners can <a href="https://abb.sharepoint.com/sites/powerplatformhub/SitePages/KnowledgeBase/Recertification.aspx#environment-owner-how-to-restore-deleted-element">restore the solution</a> if needed. 
                    </div>
                }
            </div>
            <DialogFooter>
                <PrimaryButton onClick={closeDialog} text="Close" />
            </DialogFooter>
        </Dialog>

    return (
        requestSavedDialog
    )
}

export default DeletePowerAppSolutionConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppEditElements/DeletePowerAppSolutionConfirmationDialog.js